import { forwardRef } from "react";

import Icon from "@/components/Icon";
import SubjectStemFilledIcon from "./SubjectStemFilled.svg.jsx";

const SubjectStemFilledIconComponent = forwardRef((props, ref) => {
  return (
    <Icon
      ref={ref}
      SvgComponent={SubjectStemFilledIcon}
      title="Subject Stem filled icon"
      {...props}
    />
  );
});

SubjectStemFilledIconComponent.displayName = "SubjectStemFilledIconComponent";
export default SubjectStemFilledIconComponent;
